export type VanHoaEmailTemplatePageConfig = {
  type: string;
  title: string;
  i18nKey: string;
};

type SurveySteps = {
  moi?: { type: string; title: string; i18nKey: string };
  lamBai: { type: string; title: string; i18nKey: string };
  nhac1: { type: string; title: string; i18nKey: string };
  nhac2: { type: string; title: string; i18nKey: string };
  nhac3: { type: string; title: string; i18nKey: string };
  ketThuc: { type: string; title: string; i18nKey: string };
};

const buildSurveyFlowPages = (
  basePath: string,
  steps: SurveySteps,
): Record<string, VanHoaEmailTemplatePageConfig> => {
  const pages: Record<string, VanHoaEmailTemplatePageConfig> = {
    [`${basePath}/lam-bai-khao-sat`]: steps.lamBai,
    [`${basePath}/nhac-lan-1`]: steps.nhac1,
    [`${basePath}/nhac-lan-2`]: steps.nhac2,
    [`${basePath}/nhac-lan-3`]: steps.nhac3,
    [`${basePath}/ket-thuc`]: steps.ketThuc,
  };
  if (steps.moi) {
    pages[`${basePath}/moi-tham-gia`] = steps.moi;
  }
  return pages;
};

/** Route (sau `van-hoa/cau-hinh-email/mau-mail/`) → cấu hình trang mẫu email VH */
export const VAN_HOA_EMAIL_TEMPLATE_PAGES: Record<string, VanHoaEmailTemplatePageConfig> = {
  // —— Đánh giá văn hóa hiện tại tương lai ——
  ...buildSurveyFlowPages('danh-gia-van-hoa-hien-tai-tuong-lai', {
    lamBai: {
      type: 'danhgiavanhoacongty',
      title: 'Mẫu email bắt đầu đánh giá văn hóa hiện tại và văn hóa kỳ vọng',
      i18nKey: 'bsc.label.mauemailbatdaudanhgiavanhoa',
    },
    nhac1: {
      type: 'nhacnho1danhgiavanhoacongty',
      title: 'Mẫu email nhắc nhở lần 1 đánh giá văn hóa hiện tại tương lai',
      i18nKey: 'bsc.label.mauemailnhacnho1danhgiavanhoacongty',
    },
    nhac2: {
      type: 'nhacnho2danhgiavanhoacongty',
      title: 'Mẫu email nhắc nhở lần 2 đánh giá văn hóa hiện tại tương lai',
      i18nKey: 'bsc.label.mauemailnhacnho2danhgiavanhoacongty',
    },
    nhac3: {
      type: 'nhacnho3danhgiavanhoacongty',
      title: 'Mẫu email nhắc nhở lần 3 đánh giá văn hóa hiện tại tương lai',
      i18nKey: 'bsc.label.mauemailnhacnho3danhgiavanhoacongty',
    },
    ketThuc: {
      type: 'ketthucdanhgiavanhoacongty',
      title: 'Mẫu email kết thúc đánh giá văn hóa công ty (hiện tại)',
      i18nKey: 'bsc.label.mauemailketthucdanhgiavanhoa',
    },
  }),

  // —— Tiêu chí lãnh đạo — Leader ——
  ...buildSurveyFlowPages('tieu-chi-lanh-dao/leader', {
    moi: {
      type: 'moilddanhgiatieuchi',
      title: 'Mẫu email Leader mời đánh giá tiêu chí',
      i18nKey: 'bsc.label.mauemailleadermoidanhgiatieuchi',
    },
    lamBai: {
      type: 'lambailddanhgiatieuchi',
      title: 'Mẫu email Leader làm bài đánh giá tiêu chí',
      i18nKey: 'bsc.label.mauemailleaderlambaidanhgiatieuchi',
    },
    nhac1: {
      type: 'nhacnho1lddanhgiatieuchi',
      title: 'Mẫu email nhắc nhở lần 1 Leader đánh giá tiêu chí',
      i18nKey: 'bsc.label.mauemailnhacnho1leaderdanhgiatieuchi',
    },
    nhac2: {
      type: 'nhacnho2lddanhgiatieuchi',
      title: 'Mẫu email nhắc nhở lần 2 Leader đánh giá tiêu chí',
      i18nKey: 'bsc.label.mauemailnhacnho2leaderdanhgiatieuchi',
    },
    nhac3: {
      type: 'nhacnho3lddanhgiatieuchi',
      title: 'Mẫu email nhắc nhở lần 3 Leader đánh giá tiêu chí',
      i18nKey: 'bsc.label.mauemailnhacnho3leaderdanhgiatieuchi',
    },
    ketThuc: {
      type: 'ketthuclddanhgiatieuchi',
      title: 'Mẫu email kết thúc đánh giá tiêu chí lãnh đạo hình mẫu',
      i18nKey: 'bsc.label.mauemailketthucleaderdanhgiatieuchi',
    },
  }),

  // —— Tiêu chí lãnh đạo — Stakeholder ——
  ...buildSurveyFlowPages('tieu-chi-lanh-dao/stakeholder', {
    moi: {
      type: 'moishdanhgiatieuchi',
      title: 'Mẫu email Stakeholder mời đánh giá tiêu chí',
      i18nKey: 'bsc.label.mauemailstakeholdermoidanhgiatieuchi',
    },
    lamBai: {
      type: 'lambaishdanhgiatieuchi',
      title: 'Mẫu email Stakeholder làm bài đánh giá tiêu chí',
      i18nKey: 'bsc.label.mauemailstakeholderlambaidanhgiatieuchi',
    },
    nhac1: {
      type: 'nhacnho1shdanhgiatieuchi',
      title: 'Mẫu email nhắc nhở lần 1 Stakeholder đánh giá tiêu chí',
      i18nKey: 'bsc.label.mauemailnhacnho1stakeholderdanhgiatieuchi',
    },
    nhac2: {
      type: 'nhacnho2shdanhgiatieuchi',
      title: 'Mẫu email nhắc nhở lần 2 Stakeholder đánh giá tiêu chí',
      i18nKey: 'bsc.label.mauemailnhacnho2stakeholderdanhgiatieuchi',
    },
    nhac3: {
      type: 'nhacnho3shdanhgiatieuchi',
      title: 'Mẫu email nhắc nhở lần 3 Stakeholder đánh giá tiêu chí',
      i18nKey: 'bsc.label.mauemailnhacnho3stakeholderdanhgiatieuchi',
    },
    ketThuc: {
      type: 'ketthucshdanhgiatieuchi',
      title: 'Mẫu email kết thúc đánh giá tiêu chí Stakeholder',
      i18nKey: 'bsc.label.mauemailketthucstakeholderdanhgiatieuchi',
    },
  }),

  // —— Tiêu chí kế thừa hình mẫu — Leader ——
  ...buildSurveyFlowPages('tieu-chi-ke-thua-hinh-mau/leader', {
    moi: {
      type: 'moilddanhgiatieuchikethua',
      title: 'Mẫu email Leader mời đánh giá tiêu chí kế thừa hình mẫu',
      i18nKey: 'bsc.label.mauemailleadermoidanhgiatieuchikethua',
    },
    lamBai: {
      type: 'lambailddanhgiatieuchikethua',
      title: 'Mẫu email Leader làm bài đánh giá tiêu chí kế thừa hình mẫu',
      i18nKey: 'bsc.label.mauemailleaderlambaidanhgiatieuchikethua',
    },
    nhac1: {
      type: 'nhacnho1lddanhgiatieuchikethua',
      title: 'Mẫu email nhắc nhở lần 1 Leader đánh giá tiêu chí kế thừa hình mẫu',
      i18nKey: 'bsc.label.mauemailnhacnho1leaderdanhgiatieuchikethua',
    },
    nhac2: {
      type: 'nhacnho2lddanhgiatieuchikethua',
      title: 'Mẫu email nhắc nhở lần 2 Leader đánh giá tiêu chí kế thừa hình mẫu',
      i18nKey: 'bsc.label.mauemailnhacnho2leaderdanhgiatieuchikethua',
    },
    nhac3: {
      type: 'nhacnho3lddanhgiatieuchikethua',
      title: 'Mẫu email nhắc nhở lần 3 Leader đánh giá tiêu chí kế thừa hình mẫu',
      i18nKey: 'bsc.label.mauemailnhacnho3leaderdanhgiatieuchikethua',
    },
    ketThuc: {
      type: 'ketthuclddanhgiatieuchikethua',
      title: 'Mẫu email kết thúc đánh giá tiêu chí kế thừa hình mẫu (Leader)',
      i18nKey: 'bsc.label.mauemailketthucleaderdanhgiatieuchikethua',
    },
  }),

  // —— Tiêu chí kế thừa hình mẫu — Stakeholder ——
  ...buildSurveyFlowPages('tieu-chi-ke-thua-hinh-mau/stakeholder', {
    moi: {
      type: 'moishdanhgiatieuchikethua',
      title: 'Mẫu email Stakeholder mời đánh giá tiêu chí kế thừa hình mẫu',
      i18nKey: 'bsc.label.mauemailstakeholdermoidanhgiatieuchikethua',
    },
    lamBai: {
      type: 'lambaishdanhgiatieuchikethua',
      title: 'Mẫu email Stakeholder làm bài đánh giá tiêu chí kế thừa hình mẫu',
      i18nKey: 'bsc.label.mauemailstakeholderlambaidanhgiatieuchikethua',
    },
    nhac1: {
      type: 'nhacnho1shdanhgiatieuchikethua',
      title: 'Mẫu email nhắc nhở lần 1 Stakeholder đánh giá tiêu chí kế thừa hình mẫu',
      i18nKey: 'bsc.label.mauemailnhacnho1stakeholderdanhgiatieuchikethua',
    },
    nhac2: {
      type: 'nhacnho2shdanhgiatieuchikethua',
      title: 'Mẫu email nhắc nhở lần 2 Stakeholder đánh giá tiêu chí kế thừa hình mẫu',
      i18nKey: 'bsc.label.mauemailnhacnho2stakeholderdanhgiatieuchikethua',
    },
    nhac3: {
      type: 'nhacnho3shdanhgiatieuchikethua',
      title: 'Mẫu email nhắc nhở lần 3 Stakeholder đánh giá tiêu chí kế thừa hình mẫu',
      i18nKey: 'bsc.label.mauemailnhacnho3stakeholderdanhgiatieuchikethua',
    },
    ketThuc: {
      type: 'ketthucshdanhgiatieuchikethua',
      title: 'Mẫu email kết thúc đánh giá tiêu chí kế thừa hình mẫu (Stakeholder)',
      i18nKey: 'bsc.label.mauemailketthucstakeholderdanhgiatieuchikethua',
    },
  }),

  // —— Đánh giá bộ phận hình mẫu ——
  ...buildSurveyFlowPages('danh-gia-bo-phan-hinh-mau', {
    moi: {
      type: 'moidanhgiabophanhinhmau',
      title: 'Mẫu email mời đánh giá bộ phận hình mẫu',
      i18nKey: 'bsc.label.mauemailmoidanhgiabophanhinhmau',
    },
    lamBai: {
      type: 'lambaidanhgiabophanhinhmau',
      title: 'Mẫu email làm bài đánh giá bộ phận hình mẫu',
      i18nKey: 'bsc.label.mauemaillambaidanhgiabophanhinhmau',
    },
    nhac1: {
      type: 'nhacnho1danhgiabophanhinhmau',
      title: 'Mẫu email nhắc nhở lần 1 đánh giá bộ phận hình mẫu',
      i18nKey: 'bsc.label.mauemailnhacnho1danhgiabophanhinhmau',
    },
    nhac2: {
      type: 'nhacnho2danhgiabophanhinhmau',
      title: 'Mẫu email nhắc nhở lần 2 đánh giá bộ phận hình mẫu',
      i18nKey: 'bsc.label.mauemailnhacnho2danhgiabophanhinhmau',
    },
    nhac3: {
      type: 'nhacnho3danhgiabophanhinhmau',
      title: 'Mẫu email nhắc nhở lần 3 đánh giá bộ phận hình mẫu',
      i18nKey: 'bsc.label.mauemailnhacnho3danhgiabophanhinhmau',
    },
    ketThuc: {
      type: 'ketthucdanhgiabophanhinhmau',
      title: 'Mẫu email kết thúc đánh giá bộ phận hình mẫu',
      i18nKey: 'bsc.label.mauemailketthucdanhgiabophanhinhmau',
    },
  }),

  // —— Khảo sát trải nghiệm nhân viên (không có Mời tham gia) ——
  ...buildSurveyFlowPages('khao-sat-trai-nghiem-nhan-vien', {
    lamBai: {
      type: 'trainghiemnhanvien',
      title: 'Mẫu email bắt đầu khảo sát trải nghiệm nhân viên',
      i18nKey: 'bsc.label.mauemailbatdautrainghiemnhanvien',
    },
    nhac1: {
      type: 'nhacnho1trainghiemnhanvien',
      title: 'Mẫu email nhắc nhở lần 1 khảo sát trải nghiệm nhân viên',
      i18nKey: 'bsc.label.mauemailnhacnho1trainghiemnhanvien',
    },
    nhac2: {
      type: 'nhacnho2trainghiemnhanvien',
      title: 'Mẫu email nhắc nhở lần 2 khảo sát trải nghiệm nhân viên',
      i18nKey: 'bsc.label.mauemailnhacnho2trainghiemnhanvien',
    },
    nhac3: {
      type: 'nhacnho3trainghiemnhanvien',
      title: 'Mẫu email nhắc nhở lần 3 khảo sát trải nghiệm nhân viên',
      i18nKey: 'bsc.label.mauemailnhacnho3trainghiemnhanvien',
    },
    ketThuc: {
      type: 'ketthuctrainghiemnhanvien',
      title: 'Mẫu email kết thúc khảo sát trải nghiệm nhân viên',
      i18nKey: 'bsc.label.mauemailketthuctrainghiemnhanvien',
    },
  }),

  // —— Đánh giá sức khỏe doanh nghiệp (không có Mời tham gia) ——
  ...buildSurveyFlowPages('danh-gia-suc-khoe-doanh-nghiep', {
    lamBai: {
      type: 'truongthanhvanhoa',
      title: 'Mẫu email bắt đầu đánh giá sức khỏe doanh nghiệp',
      i18nKey: 'bsc.label.mauemailbatdausuckhoedoanhnghiep',
    },
    nhac1: {
      type: 'nhacnho1truongthanhvanhoa',
      title: 'Mẫu email nhắc nhở lần 1 đánh giá sức khỏe doanh nghiệp',
      i18nKey: 'bsc.label.mauemailnhacnho1suckhoedoanhnghiep',
    },
    nhac2: {
      type: 'nhacnho2truongthanhvanhoa',
      title: 'Mẫu email nhắc nhở lần 2 đánh giá sức khỏe doanh nghiệp',
      i18nKey: 'bsc.label.mauemailnhacnho2suckhoedoanhnghiep',
    },
    nhac3: {
      type: 'nhacnho3truongthanhvanhoa',
      title: 'Mẫu email nhắc nhở lần 3 đánh giá sức khỏe doanh nghiệp',
      i18nKey: 'bsc.label.mauemailnhacnho3suckhoedoanhnghiep',
    },
    ketThuc: {
      type: 'ketthuctruongthanhvanhoa',
      title: 'Mẫu email kết thúc đánh giá sức khỏe doanh nghiệp',
      i18nKey: 'bsc.label.mauemailketthucsuckhoedoanhnghiep',
    },
  }),
};

export const getVanHoaEmailTemplatePageConfig = (
  segments: string[] | undefined,
): VanHoaEmailTemplatePageConfig | null => {
  if (!segments?.length) return null;
  return VAN_HOA_EMAIL_TEMPLATE_PAGES[segments.join('/')] ?? null;
};
